var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose3 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillRule: "evenodd",
    d: "M15.502 13.991L27.663 1.824c.42-.42.42-1.103 0-1.523-.42-.42-1.103-.42-1.523 0L13.979 12.468 1.818.301c-.42-.42-1.103-.42-1.523 0-.42.42-.42 1.103 0 1.523l12.161 12.167L.295 26.158c-.42.421-.42 1.104 0 1.524.211.211.487.315.763.315.275 0 .551-.106.762-.315l12.161-12.167 12.162 12.167c.211.211.486.315.762.315s.552-.106.763-.315c.42-.42.42-1.103 0-1.524L15.506 13.991h-.004z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close3.2e5d7ad2.svg";
export { ForwardRef as ReactComponent };